export default {
	text: "Unknown activity: {discriminator} {activityType}",
};
